import AppIcon from '../../../components/AppIcon';
import { formatNumber } from '../../../utils/formatNumber';

const EmailQueueList = ({ queueItems }) => {
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleString('ar-SA', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusConfig = (status) => {
    const configs = {
      pending: {
        label: 'قيد المعالجة',
        icon: 'Clock',
        color: 'var(--color-warning)',
        bgColor: 'bg-warning/10',
        textColor: 'text-warning'
      },
      scheduled: {
        label: 'مجدول',
        icon: 'Calendar',
        color: 'var(--color-primary)',
        bgColor: 'bg-primary/10',
        textColor: 'text-primary'
      },
      processing: {
        label: 'جاري الإرسال',
        icon: 'Loader',
        color: 'var(--color-accent)',
        bgColor: 'bg-accent/10',
        textColor: 'text-accent'
      }
    };
    return configs?.[status] || configs?.pending;
  };

  const getPriorityConfig = (priority) => {
    const configs = {
      high: { label: 'عالية', color: 'var(--color-error)' },
      medium: { label: 'متوسطة', color: 'var(--color-warning)' },
      low: { label: 'منخفضة', color: 'var(--color-muted-foreground)' }
    };
    return configs?.[priority] || configs?.medium;
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-foreground">قائمة انتظار الإيميلات</h2>
            <p className="text-sm text-muted-foreground mt-1">
              {formatNumber(queueItems?.length?.toString())} إيميل في الانتظار
            </p>
          </div>
          <AppIcon name="List" size={24} className="text-primary" />
        </div>
      </div>

      <div className="divide-y divide-border max-h-[600px] overflow-y-auto">
        {queueItems?.map(item => {
          const statusConfig = getStatusConfig(item?.status);
          const priorityConfig = getPriorityConfig(item?.priority);

          return (
            <div key={item?.id} className="p-4 hover:bg-muted/30 transition-colors">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold text-foreground text-sm">{item?.recipient}</h3>
                    <span 
                      className="w-2 h-2 rounded-full"
                      style={{ backgroundColor: priorityConfig?.color }}
                      title={`أولوية ${priorityConfig?.label}`}
                    />
                  </div>
                  <p className="text-xs text-muted-foreground">{item?.email}</p>
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${statusConfig?.bgColor} ${statusConfig?.textColor}`}>
                  <AppIcon name={statusConfig?.icon} size={12} />
                  {statusConfig?.label}
                </span>
              </div>

              <div className="mb-2">
                <p className="text-sm text-foreground">{item?.template}</p>
              </div>

              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <div className="flex items-center gap-1">
                  <AppIcon name="Clock" size={12} />
                  <span>موعد الإرسال: {formatTime(item?.scheduledTime)}</span>
                </div>
                <button className="text-primary hover:underline">
                  عرض التفاصيل
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EmailQueueList;